<script setup lang="ts">
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskLayout> in <template>
import KioskLayout from '@/app/layouts/kiosk/KioskLayout.vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <GoPhotoUploadPanel> in <template>
import GoPhotoUploadPanel from './gophoto-upload/GoPhotoUploadPanel.vue';
import { useGoPhotoUploadFlow } from './gophoto-upload/useGoPhotoUploadFlow';
import { useTranslateOr } from './gophoto-upload/useTranslateOr';

const {
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  errorMessage,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  failedUuids,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  finishWithPartial,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  gophotoCode,
  publicApi,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  retry,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  retryFailed,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  showGophotoCode,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  successCount,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  totalCount,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  uploadedCount,
  // biome-ignore lint/correctness/noUnusedVariables: used in <template>
  viewState,
} = useGoPhotoUploadFlow({ translate: useTranslateOr().translateOr });

defineExpose(publicApi);
</script>

<template>
  <KioskLayout :is-centered="true">
    <GoPhotoUploadPanel
      :error-message="errorMessage"
      :failed-uuids="failedUuids"
      :gophoto-code="gophotoCode"
      :show-gophoto-code="showGophotoCode"
      :state="viewState"
      :success-count="successCount"
      :total-count="totalCount"
      :uploaded-count="uploadedCount"
      @done="finishWithPartial"
      @retry="retry"
      @retry-failed="retryFailed"
    />
  </KioskLayout>
</template>
